import type { Issue } from "@/types/repo";
import { ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

interface Props {
  issues: Issue[];
}

const DIFF_COLOR: Record<string, string> = {
  beginner: "bg-emerald-50 text-emerald-800",
  intermediate: "bg-amber-50 text-amber-800",
};

export function GoodFirstIssues({ issues }: Props) {
  if (issues.length === 0) return null;

  return (
    <div className="flex flex-col gap-3">
      {issues.slice(0, 8).map((issue) => (
        <div key={issue.id} className="eth-card flex items-start gap-4 p-4">
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-center gap-2 mb-1">
              <span className="text-xs font-code text-text-muted">
                {issue.repo_name}
              </span>
              <span
                className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${DIFF_COLOR[issue.difficulty] ?? ""}`}
              >
                {issue.difficulty}
              </span>
              <span className="text-[11px] px-2 py-0.5 rounded-full bg-primary-muted text-primary">
                {issue.label}
              </span>
            </div>
            <p className="text-sm font-medium text-text-primary">
              {issue.title}
            </p>
            {issue.description && (
              <p className="text-xs text-text-muted mt-1 line-clamp-2">
                {issue.description}
              </p>
            )}
          </div>
          <Link
            to="/join"
            className="shrink-0 text-primary hover:text-primary-dark transition-colors"
            aria-label="Apply to work on this issue"
          >
            <ArrowRight size={18} weight="bold" />
          </Link>
        </div>
      ))}
    </div>
  );
}
